// extracted by mini-css-extract-plugin
export default {"Container":"Audit_Container__FLFA6","content":"Audit_content__x2bUR","section-1":"Audit_section-1__l3t0S","section-2":"Audit_section-2__ff9md"};